import styled from 'styled-components'
import { colors } from '../../styles'

export const StyledPrioritiesTable = styled.table`
  min-width: 75%;
  max-width: 100%;
  tr {
    padding: 12px 8px;
    display: grid;
    grid-template-columns: 1fr 2fr;
  }
  td,
  th {
    word-break: break-word;
    text-align: left;
  }
  tbody tr {
    cursor: pointer;
    &:hover {
      background-color: ${colors.orange10};
    }
  }
`
